// import qs from 'qs'
import _ from '@/apps/common/lodash';
import getCrud from '../get.crud';

const emptyFilter = {
    ordering: 'id'
  },
  emptyItem = {
    id: 0,
    name: '',
    active: true,
    url: '',
    batch_size: 1,
    send_attempts: 10,
    created_by: 0,
    filters: {
      face_events: createBaseWebhookEventsFilter(),
      body_events: createBaseWebhookEventsFilter(),
      car_events: createBaseWebhookEventsFilter(),
      human_episodes: {
        allowed_types: ['episode_open', 'episode_event', 'episode_close'],
        camera_group_in: [],
        camera_in: [],
        matched_lists_in: [],
        face_matched: true,
        body_matched: true,
        events_count_gte: 0,
        events_count_lte: 999
      },
      car_episodes: {
        allowed_types: ['episode_open', 'episode_event', 'episode_close'],
        camera_group_in: [],
        camera_in: [],
        matched_lists_in: [],
        car_matched: true,
        events_count_gte: 0,
        events_count_lte: 999
      },
      counters: {
        counter_in: [],
        camera_group_in: [],
        camera_in: [],
        faces_gte: 1,
        faces_lte: 100,
        silhouettes_gte: 1,
        silhouettes_lte: 100,
        cars_gte: 1,
        cars_lte: 100,
        proximity_min_lte: 100,
        proximity_min_gte: 0,
        proximity_avg_lte: 100,
        proximity_avg_gte: 0,
        proximity_max_lte: 100,
        proximity_max_gte: 0
      },
      areas: {
        area_in: [],
        camera_group_in: [],
        camera_in: []
      }
    }
  },
  Name = 'hooks',
  Action = require('../action.names').default.Hooks;

export default {
  state: {
    page: 0,
    next_page: null,
    prev_page: null,
    items: [],
    item: {
      current: _.cloneDeep(emptyItem),
      empty: emptyItem
    },
    filter: {
      empty: emptyFilter,
      current: _.cloneDeep(emptyFilter)
    },
    Action
  },
  actions: Object.assign({}, getCrud(Name))
};

function createBaseWebhookEventsFilter() {
  return {
    allowed_bs_types: ['overall', 'realtime'],
    camera_group_in: [],
    camera_in: [],
    matched_lists_in: [],
    matched_card_in: [],
    matched: true,
    confidence_gte: 0.75
  };
}
